import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { OrderService } from '@draeger-academy/common/lib/services/order/order.service';
import { GenericModalService } from '@draeger-academy/presentation/lib/modules/generic-modal';
import { Order } from 'models/order';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Router } from '@angular/router';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';
import { animate, animateChild, group, query, stagger, state, style, transition, trigger } from '@angular/animations';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { AuthenticationService } from '@draeger-academy/common';

@Component({
    selector: 'da-booking-summary',
    templateUrl: './booking-summary.component.html',
    styleUrls: ['./booking-summary.component.scss'],
    animations: [
        trigger('flyInOut', [
            transition(':leave', [
                group([
                    animate('0.5s ease', style({ transform: 'translateY(-20%)', height: '0px' })),
                    animate('0.5s 0.2s ease', style({ opacity: 0 }))
                ])
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BookingSummaryComponent implements OnInit {
    @Input() activeStep: number;
    @Output()
    nextStep: EventEmitter<string> = new EventEmitter<string>();
    public showErrorMessage = false;
    public agreed = false;
    public showErrorRequired = false;
    public countryCode: string;
    private _modalId: string;
    @ViewChild('overlay', { static: true }) private _overlay;
    public totalPrice: number;
    public onlyWebinars = false;
    public isLoggedInUser: boolean;
    public site: string;
    public portalID: string;
    public salutationData: any;
    public _$order: BehaviorSubject<any> = new BehaviorSubject([]);
    public get order$(): Observable<Order> {
        return this._$order.asObservable();
    }
    public _$bookingSuccessfullyDone: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public _$submitClicked: BehaviorSubject<boolean> = new BehaviorSubject(false);

    public get submitClicked$(): Observable<boolean> {
        return this._$submitClicked.asObservable();
    }

    public get bookingSuccessfullyDone$(): Observable<boolean> {
        return this._$bookingSuccessfullyDone.asObservable();
    }

    public _$showErrorMessage: BehaviorSubject<any> = new BehaviorSubject(false);
    public get showErrorMessage$(): Observable<boolean> {
        return this._$showErrorMessage.asObservable();
    }

    constructor(
        private orderService: OrderService,
        private _genericModalService: GenericModalService,
        private router: Router,
        private _localizeRouterService: LocalizeRouterService,
        private _configurationService: ConfigurationService,
        private _cartService: CartService,
        private authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.authenticationService.loggedIn().subscribe((data) => {
            if (data) {
                this.isLoggedInUser = true;
            } else {
                this.isLoggedInUser = false;
            }
        });

        this.orderService.order$.subscribe((order) => {
            this._$order.next(order);
        });

        const isPortal = this._configurationService.isPartnerPage();
        if (isPortal) {
            this.portalID = this._configurationService.portalId;
            this.countryCode = JSON.parse(localStorage.getItem('portalCountryCode')).countryCode;
        }
        if (this._$order.getValue().cartItems.length > 0) {
            this.checkIfOnlyWebinarsInOrder();
        }
    }

    public isActive(currentStep: number) {
        if (currentStep < Number(this.activeStep)) {
            return true;
        }
    }

    public isCurrent(currentStep: number) {
        if (currentStep === Number(this.activeStep)) {
            return true;
        }
    }

    goToStep(stepNumber) {
        if (!this._$submitClicked.getValue()) {
            this._$submitClicked.next(true);
            this._cartService.ordersent = false;
            this.showErrorRequired = false;
            const isPortal = this._configurationService.isPartnerPage();
            const currentPortal = this._configurationService.portalId;
            this.site = this._configurationService.getSiteFromUrl();
            if (this.site) {
                this.site = this._configurationService.getSiteFromUrl().site;
            }
            const _site = isPortal ? currentPortal : this.site;
            this.site = _site;
            this.showErrorMessage = false;
            if (stepNumber === 4) {
                if (this.agreed) {
                    this._$order.pipe(take(1)).subscribe((order) => {
                        if (
                            !this.onlyWebinars ||
                            !this.isLoggedInUser ||
                            // (this.site !== 'de_ch' && this.site !== 'fr_ch' && this.site !== 'ch-ext-sd' && this.site !== 'ch-ext-md')
                            this.site !== 'xyz'
                        ) {
                            this.getValuesForSalutationsForBookingObject(order);
                            this.orderService
                                .submitOrder(order, this.totalPrice)
                                .then((data) => {
                                    if (data) {
                                        this._$bookingSuccessfullyDone.next(true);
                                        this.nextStep.emit(stepNumber);
                                        this._cartService.ordersent = true;
                                        this._cartService.clearCart();
                                    } else {
                                        this._$showErrorMessage.next(true);
                                        this.showErrorMessage = true;
                                        this.goToBookingErrorPage();
                                        this._$bookingSuccessfullyDone.next(false);
                                    }
                                })
                                .catch((error) => {
                                    console.log(error);
                                    this._$showErrorMessage.next(true);
                                    this.showErrorMessage = true;
                                    this.goToBookingErrorPage();
                                });
                        } else {
                            if (order) {
                                this._$order.next(order);
                                this._$bookingSuccessfullyDone.next(true);
                                this._cartService.ordersent = true;
                                this._cartService.clearCart();
                            } else {
                                this._$showErrorMessage.next(true);
                                this.showErrorMessage = true;
                                this.goToBookingErrorPage();
                                this._$bookingSuccessfullyDone.next(false);
                            }
                        }
                    });
                } else {
                    this.showErrorRequired = true;
                }
            } else {
                this.nextStep.emit(stepNumber);
            }
        }
    }

    removeParticipant(index) {
        // let card = document.getElementById('card' + index) as HTMLElement;
        // card.classList.add('fadeOut');
        // setTimeout(function () {
        //     this.removeParticipantFromArray(index);
        // }, 500);
        this.orderService.order$.pipe(take(1)).subscribe((order) => {
            if (order.participants) {
                order.participants.splice(index, 1);
            }
            this._$order.next(order);
            this.orderService.updateOrder(order);
        });
    }

    checked() {
        this.agreed = !this.agreed;
        this._$submitClicked.next(false);
    }

    public showWarning(): void {
        this._overlayHandler();
    }

    private async _overlayHandler(): Promise<void> {
        this._modalId = this._genericModalService.create(this._overlay);
        this._genericModalService.open(this._modalId, this._overlay, true);
    }

    public closeModal() {
        this._genericModalService.close(this._modalId);
    }

    public goToEditParticipants() {
        this._genericModalService.close(this._modalId);
        this.goToStep(2);
    }

    public cancleOrder() {
        this._$order.next([]);
        this.closeModal();
        this.orderService.cancleOrder();

        if (this.portalID) {
            this.router.navigate(['/partner/' + this.portalID]);
        } else {
            const translatedPath: any = this._localizeRouterService.translateRoute('/' + 'courses');
            this.router.navigate([translatedPath]);
        }
    }

    public goToBookingErrorPage() {
        const isPortal = this._configurationService.isPartnerPage();
        if (isPortal) {
            const url = window.location.href;
            const arrayUrl = url.split('/');
            arrayUrl.pop();
            const newUrl = arrayUrl.join('/');
            window.location.href = newUrl + '/booking-error';
        } else {
            const translatedPath: any = this._localizeRouterService.translateRoute('/' + 'booking-error');
            this.router.navigate([translatedPath]);
        }
    }

    public getTotalPrice(price) {
        this.totalPrice = price;
    }

    private checkIfOnlyWebinarsInOrder() {
        this.onlyWebinars = true;
        for (const i of this._$order.getValue().cartItems) {
            if (i.courseType !== 'WBT') {
                this.onlyWebinars = false;
            }
            break;
        }
    }

    private getValuesForSalutationsForBookingObject(order) {
        this.salutationData = this._configurationService.$allSalutationsByLanguage.getValue();
        const salutationUser = this.salutationData.filter((item) => item.key === order.user.salutation);
        const salutationBilling = this.salutationData.filter((item) => item.key === order.billing.salutation);

        if (salutationUser && salutationUser[0]) {
            order.user.salutation = salutationUser[0].value;
        }
        if (salutationBilling && salutationBilling[0]) {
            order.billing.salutation = salutationBilling[0].value;
        }
        order.participants.forEach((object) => {
            if (object.person.salutation) {
                const salutationParticipant = this.salutationData.filter((item) => item.key === object.person.salutation);
                if (salutationParticipant && salutationParticipant[0]) {
                    object.person.salutation = salutationParticipant[0].value;
                }
            }
        });
    }
}
